import "reflect-metadata";
import {inject, injectable} from "inversify";
import {TicketRepository} from "@dropDesk/domain/repositories/ticket/ticket.repository";
import {ExportTicketStatusEntity} from "@dropDesk/domain/entities/ticket/export_ticket_status.entity";

@injectable()
export class DeleteExportHTMLTicketsUseCase {
    private _repository: TicketRepository;

    constructor(@inject(TicketRepository) repository: TicketRepository) {
        this._repository = repository;
    }

    public call(): Promise<void> {
        return this._repository.deleteExportHTML();
    }
}
